import "./confirmShareDialog.scss";
import { useState, useEffect } from "react";
import { DialogContent } from "@mui/material";
import UKDialog from "@/components/UKDialog";
import { Button } from "@mui/material";
import { useTranslation } from "@/i18n/client";

type Props = {
  open: boolean;
  closeFn: any;
  confirmShareMsg: any;
};

const DialogStyle = {
  "& .MuiDialog-paper": {
    width: "592px",
    margin: "0",
  },
  "& .MuiDialogTitle-root": {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "20px",
    padding: "20px 24px 20px 24px",
  },
};

export default function ConfirmShareDialog({ open, closeFn, confirmShareMsg }: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const closeHandler = () => {
    setIsOpen(false);
    closeFn && closeFn();
  };
  const close = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <UKDialog open={isOpen} onClose={closeHandler} showCloseBtn={false} sx={DialogStyle} className="confirmShareWrap">
      <DialogContent>
        <p className="text">{confirmShareMsg ? confirmShareMsg : t("profile.inviteFriend.confirmShareMsg")}</p>
        <div className="btnWwap">
          <Button className="btn btn1" variant="outlined" onClick={close}>
            {t("common.btnText.no")}
          </Button>
          <Button className="btn btn2" variant="contained" onClick={closeHandler}>
            {t("common.btnText.yes")}
          </Button>
        </div>
      </DialogContent>
    </UKDialog>
  );
}
